import * as classNames from 'classnames'
import * as React from 'react'
import CheckMark from '../../icons/ui/CheckMark'

export enum EntityStepState {
  COMPLETED = 'completed',
  CURRENT = 'current',
  REGULAR = 'regular'
}

export interface IEntityStepBarItemProps {
  index: number
  state?: EntityStepState
  children: any
}

const EntityStepBarItem = ({ index, state = EntityStepState.REGULAR, children }: IEntityStepBarItemProps) => {
  const tabBarItemStyle = 'pt1 pb2 flex items-center ml3'

  const tabBarItemIndexStyle = classNames(
    'flex justify-center items-center icon--36x36 h5 circle bold center border-box',
    { 'color-white bg-green': state === EntityStepState.COMPLETED },
    {
      'border-width-2 border-green font-dark-grey bg-white': state === EntityStepState.CURRENT
    },
    {
      'border-width-2 border-light-blue-grey font-light-blue-grey': state === EntityStepState.REGULAR
    }
  )

  const tabBarItemTitleStyle = classNames(
    'h5 bold center uppercase ml1',
    { 'font-green': state === EntityStepState.COMPLETED },
    { 'font-dark-grey': state === EntityStepState.CURRENT },
    { 'font-light-blue-grey': state === EntityStepState.REGULAR }
  )

  return (
    <div className={tabBarItemStyle}>
      <div className={tabBarItemIndexStyle}>
        {state === EntityStepState.COMPLETED ? (
          <CheckMark className='relative' />
        ) : (
          <div className='center'>{index}</div>
        )}
      </div>
      <div className={tabBarItemTitleStyle}>{children}</div>
    </div>
  )
}

export default EntityStepBarItem



// WEBPACK FOOTER //
// ./src/components/ui/entity/EntityStepBarItem.tsx